'use client';

import { useGSAP } from '@gsap/react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import initAnimation from './animation/read-text-animation';
import { useRef } from 'react';
import { useLocale } from '@/components/providers/context/locale-context';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';
import TerraImage from './terra-image';

export default function ReadText() {
    const rootRef = useRef<HTMLElement>(null);
    const { t } = useTranslation('terra1-readtext');
    const locale = useLocale();

    const readTexts: string[] = t('readTexts', {
        returnObjects: true,
    }) as string[];

    useGSAP(
        () => {
            initAnimation();
        },
        { scope: rootRef },
    );

    return (
        <section
            ref={rootRef}
            className="desktop:py-[184px] desktop:px-0 relative flex w-full flex-col items-center justify-center overflow-hidden bg-black px-[44px] py-[80px]"
        >
            <TerraImage
                wrapperClassName="!absolute inset-0"
                imageClassName="object-cover object-center"
                alt="text background"
                fill
                src={getStaticAssetUrl('/terra1/bg-readtext.webp')}
                skeletonClassName="bg-[#121217]"
            />
            <div className="absolute inset-x-0 top-0 h-1/3 bg-gradient-to-b from-black to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black to-transparent" />

            <div
                className={clsx(
                    'j-h4 desktop:block desktop:w-[820px] hidden w-full text-center text-white',
                )}
            >
                {readTexts.map((text, index) => {
                    const key = `read-text-${index}`;
                    return (
                        <div
                            key={key}
                            style={{
                                opacity: 0.2,
                            }}
                            className="read-text"
                        >
                            {text}
                        </div>
                    );
                })}
            </div>
            <div
                className={clsx(
                    'j-h4 desktop:hidden desktop:w-[820px] block w-full text-center text-white',
                )}
            >
                {readTexts.map((text, index) => {
                    const key = `read-text-${index}`;
                    return (
                        <span
                            key={key}
                            style={{
                                opacity: 0.2,
                            }}
                            className="read-text"
                        >
                            {text}
                        </span>
                    );
                })}
            </div>
        </section>
    );
}
